import React from 'react';
import PropTypes from 'prop-types';

import { StyledHeaderTitle, StyledTitle, StyledSubtitle, StyledText, StyledSpan } from './style';

export const HeaderTitle = ({ children, ...rest }) => {
    return (
        <StyledHeaderTitle {...rest} variant="h1">
            {children}
        </StyledHeaderTitle>
    );
};

HeaderTitle.propTypes = {
    rest: PropTypes.object,
    children: PropTypes.any,
};

export const Title = ({ children, ...rest }) => {
    return (
        <StyledTitle {...rest} variant="h1">
            {children}
        </StyledTitle>
    );
};

Title.propTypes = {
    rest: PropTypes.object,
    children: PropTypes.any,
};

export const Subtitle = ({ children, ...rest }) => {
    return (
        <StyledSubtitle {...rest} variant="subtitle1">
            {children}
        </StyledSubtitle>
    );
};

Subtitle.propTypes = {
    rest: PropTypes.object,
    children: PropTypes.any,
};

export const Text = ({ children, onClick, disabled, ...rest }) => {
    return (
        <StyledText
            onClick={disabled ? () => {} : onClick ? (e) => onClick(e) : undefined}
            {...rest}
            disabled={disabled}
        >
            {children}
        </StyledText>
    );
};

Text.propTypes = {
    rest: PropTypes.object,
    children: PropTypes.any,
};

export const Span = ({ children, ...rest }) => {
    return (
        <StyledSpan {...rest} variant="inherit">
            {children}
        </StyledSpan>
    );
};

Span.propTypes = {
    rest: PropTypes.object,
    children: PropTypes.any,
};

export const NoInformation = ({ height }) => {
    return (
        <div
            style={{
                display: 'flex',
                width: '100%',
                height: height ? height : '120px',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <Text $color="gray2"> No Information</Text>
        </div>
    );
};

NoInformation.propTypes = {
    height: PropTypes.string,
};
